<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>
  This can be used as a <b>component</b>, <b>directive</b>, or <b>css</b> class.
  <br>As a component, it generates a simple template with a spinner running.
  As a directive it overlays a spinner on an existing element.
  As a css class, it directly adds a small spinner on the current element.
</p>
<ul>
  <li>{{instance}}</li>
  <li>{{directiveInstance}}</li>
  <li>{{cssInstance}}</li>
</ul>
<!--<span class="jb-loading-spinner"></span>-->

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>




<!--Component usage-->
<div class="whiteBg">
  <div class="row">
    <div class="col-5 marB15">
      <h5 class="marB25">Component usage:</h5>
      <div style="width: 400px; height: 150px; border: 1px dashed grey;">
        <jb-loading-spinner
                [class.xs]="compConf.size === 'xs'"
                [class.sm]="compConf.size === 'sm'"
                [class.md]="compConf.size === 'md'"
                [class.lg]="compConf.size === 'lg'"
                [class.xl]="compConf.size === 'xl'"
                [class.center]="compConf.isCenter && compConf.centerPos === 'center'"
                [class.center-top]="compConf.isCenter && compConf.centerPos === 'center-top'"
                [class.center-left]="compConf.isCenter && compConf.centerPos === 'center-left'"
                [class.center-right]="compConf.isCenter && compConf.centerPos === 'center-right'"
                [class.center-bottom]="compConf.isCenter && compConf.centerPos === 'center-bottom'"
            ></jb-loading-spinner>
      </div>

    </div>

    <div class="col-7">

      <div class="row marT15">
        <div class="col-12">
          <jb-label jbText="Size" class="marR30"></jb-label>
          <jb-radio [(ngModel)]="compConf.size" jbLabel="XS" jbValue="xs" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.size" jbLabel="SM" jbValue="sm" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.size" jbLabel="MD" jbValue="md" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.size" jbLabel="LG" jbValue="lg" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.size" jbLabel="XL" jbValue="xl" (ngModelChange)="upComp()"></jb-radio>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-2"> <jb-checkbox [(ngModel)]="compConf.isCenter" (ngModelChange)="upComp()" jbLabel="Is Centered"></jb-checkbox> </div>
        <div class="col-10" [hidden]="!compConf.isCenter">
          <jb-radio jbRadioGroup="center" [(ngModel)]="compConf.centerPos" jbLabel="Center" jbValue="center" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio jbRadioGroup="center" [(ngModel)]="compConf.centerPos" jbLabel="Top" jbValue="center-top" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio jbRadioGroup="center" [(ngModel)]="compConf.centerPos" jbLabel="Left" jbValue="center-left" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio jbRadioGroup="center" [(ngModel)]="compConf.centerPos" jbLabel="Right" jbValue="center-right" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio jbRadioGroup="center" [(ngModel)]="compConf.centerPos" jbLabel="Bottom" jbValue="center-bottom" (ngModelChange)="upComp()"></jb-radio>
        </div>
      </div>

      <div class="marT25">
        <div class="code-box pad15">
          <pre>{{customCompCode}}</pre>
        </div>
      </div>

    </div>

  </div>
</div>

<!--Directive usage-->
<div class="whiteBg row">
  <h5 class="col-12 marB15">Overlay example (directive)</h5>

  <div class="col-4" *ngIf="compConf.triggerType === 'promise'">
    <div [jbLoadingSpinner]="promiseDef?.promise"
         class="pad15" style="min-height: 80px; width: 100%; border: 1px dashed grey;">
      <h6 class="marB15">Promise loading</h6>
      <jb-label class="value-list-3" jbText="Email"       jbValue="joel.barba@gmail.com"></jb-label>
      <jb-label class="value-list-3" jbText="Number"      jbValue="+353 089 422 6474"></jb-label>
      <jb-label class="value-list-3" jbText="Description" jbValue="He is a very nice guy"></jb-label>
    </div>
  </div>

  <div class="col-4" *ngIf="compConf.triggerType === 'boolean'">
    <div [jbLoadingSpinner]="loadOn"
         class="pad15" style="min-height: 80px; width: 100%; border: 1px dashed grey;">
      <h6 class="marB15">Boolean loading</h6>
      <jb-label class="value-list-3" jbText="Email"       jbValue="joel.barba@gmail.com"></jb-label>
      <jb-label class="value-list-3" jbText="Number"      jbValue="+353 089 422 6474"></jb-label>
      <jb-label class="value-list-3" jbText="Description" jbValue="He is a very nice guy"></jb-label>
    </div>
  </div>

  <div class="col-4" *ngIf="compConf.triggerType === 'observable'">
    <div [jbLoadingSpinner]="loadObs"
         class="pad15" style="min-height: 80px; width: 100%; border: 1px dashed grey;">
      <h6 class="marB15">Observable loading</h6>
      <jb-label class="value-list-3" jbText="Email"       jbValue="joel.barba@gmail.com"></jb-label>
      <jb-label class="value-list-3" jbText="Number"      jbValue="+353 089 422 6474"></jb-label>
      <jb-label class="value-list-3" jbText="Description" jbValue="He is a very nice guy"></jb-label>
    </div>
  </div>


  <div class="col-4">
    <div class="marB20">
      <jb-label jbText="Use it as a" class="marR30"></jb-label>
      <jb-radio [(ngModel)]="compConf.triggerType" jbLabel="Promise"    jbValue="promise"     (ngModelChange)="upComp2()"></jb-radio>
      <jb-radio [(ngModel)]="compConf.triggerType" jbLabel="Boolean"    jbValue="boolean"     (ngModelChange)="upComp2()"></jb-radio>
      <jb-radio [(ngModel)]="compConf.triggerType" jbLabel="Observable" jbValue="observable"  (ngModelChange)="upComp2()"></jb-radio>
    </div>

    <div [show]="compConf.triggerType === 'promise'">
      <jb-btn class="block" jbText="Run promise" (jbClick)="generatePromise()" jbType="save"></jb-btn>
      <div class="marT10">
        <jb-btn jbText="Resolve"  jbType="save"   (jbClick)="promiseDef.resolve()"></jb-btn>
        <jb-btn jbText="Reject"   jbType="save"   (jbClick)="promiseDef.reject()"></jb-btn>
      </div>
    </div>

    <div class="marT20" [show]="compConf.triggerType === 'boolean'">
      <jb-switch [(ngModel)]="loadOn"></jb-switch>
    </div>

    <div [show]="compConf.triggerType === 'observable'">
      <jb-btn jbText="New Observable" (jbClick)="loadObs = generateObs()" jbType="save"></jb-btn>
      <jb-btn jbText="Complete" (jbClick)="loadObs.complete()" jbType="save"></jb-btn>
      <div class="marT10">
        <jb-btn jbText=".next(true)"  (jbClick)="loadObs.next(true)" jbType="save"></jb-btn>
        <jb-btn jbText=".next(false)" (jbClick)="loadObs.next(false)" jbType="save"></jb-btn>
        <jb-btn jbText="Error"    (jbClick)="loadObs.error('none')" jbType="save"></jb-btn>
      </div>
    </div>


  </div>
  <div class="col-4">
    <div class="code-box pad15">
      <pre>{{overlayExample}}</pre>
    </div>
  </div>
</div>


<!--Applicable classes -->
<div class="row">
  <div class="col-12">
    <hr>
    <h5 class="mt-4">Applicable classes:</h5>
    <p>It is possible to change the size of the spinner with the classes:</p>
    <ul>
      <li>{{sizeCss.sm}}</li>
      <li>{{sizeCss.md}}</li>
      <li>{{sizeCss.lg}}</li>
      <li>{{sizeCss.xl}}</li>
    </ul>
  </div>

  <div class="col-12">
    <p>By default the spinner is an inline element. You can turn it centered to it's container applying the "<b>center"</b> class.
      By doing that though, the spinner becomes a block element.
      <br>It is also possible to center the spinner to one side only
    </p>
    <ul>
      <li>{{centerCss.top}}</li>
      <li>{{centerCss.right}}</li>
      <li>{{centerCss.left}}</li>
      <li>{{centerCss.bottom}}</li>
    </ul>
  </div>

</div>


<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">

  <div class="row">
    <div class="col-5" style="flex-flow: row; align-items: flex-end; justify-content: space-evenly">
      <jb-loading-spinner class=""></jb-loading-spinner>
      <jb-loading-spinner class="sm"></jb-loading-spinner>
      <jb-loading-spinner class="md"></jb-loading-spinner>
      <jb-loading-spinner class="lg"></jb-loading-spinner>
      <jb-loading-spinner class="xl"></jb-loading-spinner>
    </div>
    <div class="col-7"> <pre>{{instance}}</pre> </div>
  </div>

  <div class="row">
    <div class="col-5">
      <span class="jb-loading-spinner"></span>
    </div>
    <div class="col-7"> <pre>{{cssInstance}}</pre> </div>
  </div>

</div>

<!--CSS Styling-->
<div class="col-12 marT40">
  <h3>CSS Styling</h3>
  <p>The following SASS variables can be overridden to provide customized coloring:</p>
  <pre class="padL30">{{ cssReset }}</pre>
</div>
